module.exports = __webpack_public_path__ + "img/musicicon.1e4fb0fe.png";